import { PdfTemplateSection } from "@/modules/TemplatePdf/Models/sectionsPdf";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ACTION_PLAN_CONSTANTS } from "../../constants/ActionPlanConstants";
import {
  ConfigActionPlan,
  ListaSelect,
  SourceInfoDetails
} from "../../models/ActionPlan.model";
import CardInputs from "./../CardInputs/CardInputs.vue";
import CardOutputs from "./../CardOutputs/CardOutputs.vue";

@Component({
  name: "CreateData",
  components: {
    CardOutputs,
    CardInputs
  }
})
export default class CreateData extends Vue {
  @Prop() sourceInfoDetails!: SourceInfoDetails;
  @Prop() configActionPlan!: ConfigActionPlan;
  @Prop() nameActionPlan!: string;
  @Prop() pdfSections!: PdfTemplateSection[];

  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  TITLES = ACTION_PLAN_CONSTANTS.TITLES;
  selectOutput = "";
  selectFieldOutput: ListaSelect | null = null;

  changeSelectOutput(event: string) {
    this.selectOutput = event;
    if (!event) {
      this.selectFieldOutput = null;
    }
  }
}
